import { RewardsAccount } from "redmond";

export const hasUsableRewards = (rewardsAccounts: RewardsAccount[]): boolean =>
  rewardsAccounts.some(
    (account) =>
      (account.allowRewardsRedemption ?? true) &&
      account.rewardsBalance?.value > 0
  );
